<template>

    <div class="container column-center">

        <h2 class="title">¡Has Ganado!</h2>


        <template v-if="!!!tiradaExtra">
            <img :src="'https://backpromo.fiesta.es/'+result.datosPremio.imagen" :alt="result.datosPremio.nombre" class="imagen-premio">
            <h3 class="nombre-premio">{{result.datosPremio.nombre}}</h3>
            <p class="descripcion-premio" v-html="result.datosPremio.descripcion"></p>
            <!-- <h2 class="codigo" v-if="!!result.datosPremio.codigo">{{result.datosPremio.codigo}}</h2> -->
        </template>

        <template v-if="!!tiradaExtra">
            <img src="/static/img/momento-ganador/premios/tirada-gratis.png" alt="Tirada extra" class="imagen-premio">
            <a @click="extra" class="btn -extra">Volver a intentar</a>
        </template>


        <datos-direccion v-if="result.necesitaDatosDireccion && showFormularioDireccion" @complete="complete"></datos-direccion>


        <template v-if="showFinish && !!!tiradaExtra">

            <p class="big-white"><strong>¡Revisa tu email, te hemos enviado una confirmación y en breve nos pondremos en contacto contigo!</strong></p>

            <p class="big-white">Llévate una tirada extra compartiendo la promoción para que todos tus amigos también participen</p>

            <div class="share-box -links column-center">

         
                <div class="row-center btn-container">

           
                    <a @click="tryagain" target="_blank" :href="`http://www.facebook.com/sharer.php?u=${link}&t=Gana%20un%20viaje%20a%20Corea%20con%20Fiesta`" class="share-button">
                        Compartir <span class="facebook">
                            <i class="fa fa-facebook"></i>
                        </span>
                    </a>
                    <a @click="tryagain" :href="`http://twitter.com/intent/tweet?text=Gana%20un%20viaje%20a%20Corea%20con%20Fiesta&url=${link}`" target="blank" class="share-button">
                        Compartir <span class="twitter">
                            <i class="fa fa-twitter"></i>
                        </span>
                    </a>
                </div>

                <div class="row-center btn-container">
                    <a @click="tryagain"  target="_blank"  :href="`whatsapp://send?text=Gana%20un%20viaje%20a%20Corea%20con%20Fiesta%0A${link}`" data-action="share/whatsapp/share" class="share-button">
                        Compartir <span class="whatsapp">
                            <i class="fa fa-whatsapp"></i>
                        </span>
                    </a>
                    <a @click="tryagain" :href="`mailto:?subject=Gana%20un%20viaje%20a%20Corea%20con%20Fiesta&body=${link}`" target="_blank" class="share-button">
                        Compartir <span class="envelope">
                            <i class="fa fa-envelope" aria-hidden="true"></i>
                        </span>
                    </a>
        

                </div>


            </div>

            <div class="back-to-init column-center">

                <h2 class="title">¿Tienes otro código?</h2>
                <p class="big-white">¡Vuelve al inicio y prueba suerte!</p>

                <a @click="backtoInit" class="btn">Volver</a>

            </div>

        </template>

    </div>

</template>

<script>

    import datosDireccion from '@/components/view-parts/momento-ganador/datos-direccion.vue'

    import { mapActions, mapGetters } from 'vuex';

    export default {
        name: "ganador",
        mounted(){
            if(!!!this.result.necesitaDatosDireccion){
                this.showFinish = true;
            }
        },
        data() {
            return {
                showFinish: false,
                showFormularioDireccion : true
            }
        },
        methods: {
            ...mapActions(['setTiradaExtra']),
            backtoInit() {
                this.$emit('reset');
            },
            complete(){
                this.showFinish = true;
                this.showFormularioDireccion = false;
            },
            tryagain(){
                this.$emit('tryagain');
            },
            extra(){
                this.setTiradaExtra(true);
                this.tryagain();
            }
        },
        components: {
            'datos-direccion': datosDireccion,
        },
        computed: {
            ...mapGetters({
                result: 'getResultParticipacion',
                tiradaExtra : 'getShowTiradaExtra'
            }),
            link(){
                return location.href;
            }
        }
    }

</script>


// WEBPACK FOOTER //
// src/components/view-parts/momento-ganador/ganador.vue